{
  "version": 1,
  "songs": [

  
    {
      "title": "Getting Started song",
      "tracks": [
        {
          "song": "do rán",
          "name": "Samplton idea",
          "notes": "Samplton is a live performance sampler designed for playing, practicing, and performing music. It lets you organize audio tracks into pads, trigger them precisely, loop sections, and automatically move between tracks.",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/Do-ran-zac.mp3",
          "bpm": 193,
          "signature": "",
          "bars": 8,
          "repeat": "",
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": "",
          "notesVisible": true,
          "autoplay": 1
        },
        {
          "song": "do rán",
          "name": "Quantize",
          "notes": "Press Q to switch between Quantize modes. Quantize determines when a track starts, keeping transitions synchronized with the beat.Set Quantize to NONE to play samples freely without beat synchronization.",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/Do-ran-Zac1.mp3",
          "bpm": 193,
          "signature": "",
          "bars": 8,
          "repeat": 1,
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": "",
          "notesVisible": true,
          "autoplay": 1
        },
        {
          "song": "do rán",
          "name": "Keyshots",
          "notes": "All main controls are mapped to your keyboard. Open Menu → Keyshots to see all available keyboard shortcuts.",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/Do-ran-Zac2.mp3",
          "bpm": 193,
          "signature": "",
          "bars": 8,
          "repeat": 2,
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": "",
          "notesVisible": true,
          "autoplay": 1
        },
        {
          "song": "do rán",
          "name": "autoplay",
          "notes": "Autoplay automatically continues to the next track. When it is enabled, Samplton plays the tracks in sequence without requiring you to trigger each one manually.You can turn Autoplay off at any time to stay on the current track.Turn Autoplay back on when you are ready to continue to the next track",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/Do-ran-Sloha.mp3",
          "bpm": 193,
          "signature": "",
          "bars": 8,
          "repeat": 2,
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": "",
          "notesVisible": true,
          "autoplay": 1
        },
        {
          "song": "do rán",
          "name": "edit song",
          "notes": "Edit Tracks lets you manage the tracks in your song.You can enable Edit Tracks using the button in the bottom-right corner of the Songs section.",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/Do-ran-Sloha-prech-do-dnb.mp3",
          "bpm": 193,
          "signature": "",
          "bars": 8,
          "repeat": "",
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": "",
          "notesVisible": true,
          "autoplay": 1
        },
        {
          "song": "do rán",
          "name": "edit song - icons",
          "notes": "☰ — Move,✎ — Open Track Settings,× — Delete — Remove the track from the song(not library), ↻ — Upload / Replace — Upload a new audio,▤ — Load from Library — Choose an audio file you have already uploaded to your Sample Library",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/Do-ran-Dnb-zac.mp3",
          "bpm": 193,
          "signature": "",
          "bars": 32,
          "repeat": 2,
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": "",
          "notesVisible": true,
          "autoplay": 1
        },
        {
          "song": "do rán",
          "name": "SAMPLE LIBRARY",
          "notes": "Sample Library stores all your uploaded audio files in one place. You can preview your samples, delete files you no longer need, or load an existing sample into any track without uploading it again.The Sample Library is available in Edit Song mode.",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/Do-ran-Dnb-git-s.mp3",
          "bpm": 193,
          "signature": "",
          "bars": 8,
          "repeat": "",
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": "",
          "notesVisible": true,
          "autoplay": 1
        },
        {
          "song": "do rán",
          "name": "edit sample",
          "notes": "The Edit Sample button is located in the bottom-right corner of each track in Edit Song mode.You can preview, adjust the sample’s start point, BPM, number of bars, time signature, repeat count, fade time, autoplay",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/Do-ran-Dnb-git-s1.mp3",
          "bpm": 193,
          "signature": "",
          "bars": 8,
          "repeat": 2,
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": "",
          "notesVisible": true,
          "autoplay": 1
        },
        {
          "song": "do rán",
          "name": "notes & subtitles",
          "notes": "Add notes to each track to prepare lyrics, performance instructions, chord changes, or anything else you need. Enable Subtitles to display these notes directly on screen while the track is playing.",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/Do-ran-Dnb-zac.mp3",
          "bpm": 193,
          "signature": "",
          "bars": 32,
          "repeat": 1,
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": "",
          "notesVisible": true,
          "autoplay": 1
        },
        {
          "song": "do rán",
          "name": "prepare all songs",
          "notes": "Prepare All Songs loads and prepares all audio files in advance, so your entire set is ready to play instantly. Once prepared, your songs can also be played offline — ideal for live performances without a reliable internet connection.",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/Do-ran-Dnb-git-Kon-prech.mp3",
          "bpm": 193,
          "signature": "",
          "bars": 8,
          "repeat": "",
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": "",
          "notesVisible": true,
          "autoplay": 1
        },
        {
          "song": "do rán",
          "name": "Import / export",
          "notes": "Export saves your project structure and settings as a backup file. Audio files are not included. Import restores the project settings, while the audio files remain in your Sample Library.",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/Do-ran-Dnb-Spev-prech.mp3",
          "bpm": 193,
          "signature": "",
          "bars": 36,
          "repeat": "",
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": "",
          "notesVisible": true,
          "autoplay": 1
        },
        {
          "song": "do rán",
          "name": "help improve samplton",
          "notes": "Samplton is continuously evolving. If you find a bug, have an idea for a new feature, or think something could work better, please let me know. Your feedback can help shape future versions of Samplton.",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/Do-ran-dnb-syn.mp3",
          "bpm": 193,
          "signature": "",
          "bars": 36,
          "repeat": "",
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": "",
          "notesVisible": true,
          "autoplay": 1
        }
      ]
    
    },
    
    {
      "title": "song & subtitles",
      "tracks": [
        {
          "song": "mola",
          "name": "zac",
          "notes": "Subtitles",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/Mola-zac-180.mp3",
          "bpm": 180,
          "signature": "",
          "bars": 8,
          "repeat": 1,
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": "",
          "notesVisible": true,
          "autoplay": 1
        },
        {
          "song": "mola",
          "name": "zac1",
          "notes": "On each pad in the Settings section.",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/Mola-zac1.mp3",
          "bpm": 180,
          "signature": "",
          "bars": 8,
          "repeat": "",
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": "",
          "notesVisible": true,
  "autoplay": 1
        },
        {
          "song": "mola",
          "name": "sloha",
          "notes": "Next to Notes, there is a Subtitles checkbox.",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/Mola-zac-180.mp3",
          "bpm": 180,
          "signature": "",
          "bars": 8,
          "repeat": 1,
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": "",
          "notesVisible": true,
  "autoplay": 1
        },
        {
          "song": "mola",
          "name": "sloha2",
          "notes": "When checked, the subtitles will be displayed directly while the track is playing.",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/Mola-zac3.mp3",
          "bpm": 180,
          "signature": "",
          "bars": 16,
          "repeat": "",
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": "",
          "notesVisible": true,
  "autoplay": 1       },
        {
          "song": "mola",
          "name": "ref",
          "notes": "This way, you can prepare lyrics or any notes you need in advance.",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/Mola-Ref.mp3",
          "bpm": 180,
          "signature": "",
          "bars": 20,
          "repeat": "",
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": "",
          "notesVisible": true,
          "autoplay": 1
        },
        {
          "song": "mola",
          "name": "flute",
          "notes": "",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/Mola-Flute.mp3",
          "bpm": 180,
          "signature": "",
          "bars": 32,
          "repeat": "",
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": "",
          "notesVisible": true,
  "autoplay": 1
        },
        {
          "song": "mola",
          "name": "sloha",
          "notes": "",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/Mola-Sloha2.mp3",
          "bpm": 180,
          "signature": "",
          "bars": 16,
          "repeat": 2,
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": "",
          "notesVisible": true,
  "autoplay": 1      },
        {
          "song": "mola",
          "name": "do noci",
          "notes": "",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/Mola-Sloha22.mp3",
          "bpm": 180,
          "signature": "",
          "bars": 16,
          "repeat": "",
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": "",
          "notesVisible": true,
  "autoplay": 1        },
        {
          "song": "mola",
          "name": "ref",
          "notes": "",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/Mola-Ref.mp3",
          "bpm": 180,
          "signature": "",
          "bars": 20,
          "repeat": "",
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": "",
          "notesVisible": true,
  "autoplay": 1
        },
        {
          "song": "mola",
          "name": "flute",
          "notes": "",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/Mola-Bass-flute.mp3",
          "bpm": 180,
          "signature": "",
          "bars": 56,
          "repeat": "",
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": "",
          "notesVisible": true,
  "autoplay": 1
        },
        {
          "song": "mola",
          "name": "zaveer",
          "notes": "pocita sa 6 a 7",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/Mola-Bass-Koniec.mp3",
          "bpm": 180,
          "signature": 13,
          "bars": 4,
          "repeat": "",
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": "",
          "notesVisible": true,
          "autoplay": 1
        }
      ]
    },
    {
      "title": "song & autoplay",
      "tracks": [
        {
          "fadeintime": 0.1,
          "notes": "When you click Autoplay, the song will start from the first pad.",
          "repeat": 1,
          "song": "papierova fobia",
          "bpm": 100,
          "name": "click auto pad",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/08/Pap-Zac-kla.mp3",
          "bars": 4,
          "start_at": 0.01,
          "signature": 4,
          "notesVisible": true,
          "autoplay": 1
        },
        {
          "bars": 4,
          "repeat": 1,
          "bpm": 100,
          "notes": "The song will continue, and you can set as many repeats as you want.",
          "signature": 4,
          "start_at": 0.01,
          "fadeintime": 0.1,
          "name": "sloha",
          "song": "papierova fobia",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/08/Pap-Zac-Po-naruci.mp3",
          "notesVisible": true,
          "autoplay": 1 
        },
        {
          "start_at": 0.01,
          "signature": 4,
          "bars": 8,
          "repeat": 1,
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/08/Pap-Zac-Tvar.mp3",
          "name": "sloha1",
          "song": "papierova fobia",
          "bpm": 100,
          "notes": "But now Autoplay has stopped automatically because I set Autoplay to Off in the sample settings. Press Autoplay again and the song will continue.",
          "fadeintime": 0.1,
          "notesVisible": true,
          "autoplay": 0
        },
        {
          "name": "ref",
          "start_at": 0.01,
          "song": "papierova fobia",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/08/Pap-Ref.mp3",
          "notes": "Now the song continues, and it will stop again at the next track because Autoplay is set to Off there as well.",
          "bpm": 100,
          "signature": 4,
          "bars": 8,
          "fadeintime": 0.1,
          "repeat": 1,
          "notesVisible": true,
          "autoplay": 1
        },
        {
          "name": "po ref",
          "song": "papierova fobia",
          "fadeintime": 0.1,
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/08/Pap-Po-ref.mp3",
          "signature": 4,
          "bpm": 100,
          "notes": "Pretty clever, right? And Autoplay is off again.",
          "start_at": 0.01,
          "bars": 8,
          "repeat": 1,
          "notesVisible": true,
          "autoplay": 0
        },
        {
          "fadeintime": 0.1,
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/08/Pap-pre-kon.mp3",
          "bars": 8,
          "name": "pred koniec",
          "bpm": 100,
          "song": "papierova fobia",
          "repeat": 1,
          "start_at": 0.01,
          "notes": "And Autoplay is off again.",
          "signature": 4,
          "notesVisible": true,
          "autoplay": 0
        },
        {
          "fadeintime": 0.1,
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/08/Kon.mp3",
          "bars": 8,
          "notes": "Pretty clever, right?",
          "repeat": 1,
          "song": "papierova fobia",
          "name": "kon zac",
          "signature": 4,
          "bpm": 100,
          "start_at": 0.01,
          "notesVisible": true,
          "autoplay": 1
        },
        {
          "notes": "",
          "bpm": 100,
          "signature": 4,
          "fadeintime": 0.1,
          "name": "kon nastup",
          "song": "papierova fobia",
          "start_at": 0.01,
          "bars": 8,
          "repeat": 1,
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/08/Kon-nastup.mp3",
          "notesVisible": true,
          "autoplay": 1
        },
        {
          "name": "klaves",
          "fadeintime": 0.1,
          "signature": 4,
          "notes": "",
          "song": "papierova fobia",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/08/Kon-Cely.mp3",
          "start_at": 0.01,
          "bpm": 100,
          "repeat": 1,
          "bars": 26,
          "notesVisible": true,
          "autoplay": 1
        }
      ]
    },
    {
      "title": "song from 1 audio",
      "tracks": [
        {
          "song": "watergate good moog",
          "name": "watergate by moog",
          "notes": "It’s best to have your samples as separate audio files, but...",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/Watergate-Bez.mp3",
          "bpm": 174,
          "signature": "",
          "bars": 16,
          "repeat": "",
          "start_at": 0.05,
          "fadein": "on",
          "fadeintime": 0.1,
          "midiPC": "",
          "midCC": "",
          "notesVisible": true,
          "autoplay": 1
        },
        {
          "song": "watergate good moog",
          "name": "zac1",
          "notes": "If you want to experiment, you can build the whole song from a single audio file.",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/Watergate-Bez.mp3",
          "bpm": 174,
          "signature": "",
          "bars": 16,
          "repeat": "",
          "start_at": 22.07,
          "fadein": "on",
          "fadeintime": 0.1,
          "midiPC": "",
          "midCC": "",
          "notesVisible": true,
          "autoplay": 1
        },
        {
          "song": "watergate good moog",
          "name": "SPA",
          "notes": "For this, use the Start At field in Track Settings. It lets you start the song from any point you want.",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/Watergate-Bez.mp3",
          "bpm": 174,
          "signature": "",
          "bars": 16,
          "repeat": 4,
          "start_at": 44.14,
          "fadein": "on",
          "fadeintime": 0.1,
          "midiPC": "",
          "midCC": "",
          "notesVisible": true,
          "autoplay": 1
        },
        {
          "song": "watergate good moog",
          "name": "SPA ZAVER",
          "notes": "Sometimes you may need to adjust the Fade Time setting as well. If a sample starts with a click or pop, adding a short fade will make the start sound much smoother.",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/Watergate-Bez.mp3",
          "bpm": 174,
          "signature": "",
          "bars": 16,
          "repeat": "",
          "start_at": 132.42,
          "fadein": "on",
          "fadeintime": 0.1,
          "midiPC": "",
          "midCC": "",
          "notesVisible": true,
          "autoplay": 1
        },
        {
          "song": "watergate good moog",
          "name": "nastup",
          "notes": "Press the E key or click the Edit pencil in the bottom-right corner. You’ll see that every track uses the same audio file, just with different Start At points.",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/Watergate-Bez.mp3",
          "bpm": 174,
          "signature": "",
          "bars": 16,
          "repeat": "",
          "start_at": 154.49,
          "fadein": "on",
          "fadeintime": 0.1,
          "midiPC": "",
          "midCC": "",
          "notesVisible": true,
          "autoplay": 1
        },
        {
          "song": "watergate good moog",
          "name": "drum bass",
          "notes": "ENJOY",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/Watergate-Bez.mp3",
          "bpm": 174,
          "signature": "",
          "bars": 40,
          "repeat": 2,
          "start_at": 176.57,
          "fadein": "on",
          "fadeintime": 0.1,
          "midiPC": "",
          "midCC": "",
          "notesVisible": true,
          "autoplay": 1
        },
        {
          "song": "watergate good moog",
          "name": "nastup",
          "notes": "",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/Watergate-Bez.mp3",
          "bpm": 174,
          "signature": "",
          "bars": 16,
          "repeat": "",
          "start_at": 286.92,
          "fadein": "on",
          "fadeintime": 0.1,
          "midiPC": "",
          "midCC": "",
          "notesVisible": true,
          "autoplay": 1
        },
        {
          "song": "watergate good moog",
          "name": "final",
          "notes": "",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/Watergate-Bez.mp3",
          "bpm": 174,
          "signature": "",
          "bars": 16,
          "repeat": "",
          "start_at": 309,
          "fadein": "on",
          "fadeintime": 0.1,
          "midiPC": "",
          "midCC": "",
          "notesVisible": true,
          "autoplay": 1
        },
        {
          "song": "watergate good moog",
          "name": "end",
          "notes": "",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/Watergate-Bez.mp3",
          "bpm": 174,
          "signature": "",
          "bars": 16,
          "repeat": "",
          "start_at": 342.1,
          "fadein": "on",
          "fadeintime": 0.1,
          "midiPC": "",
          "midCC": "",
          "notesVisible": true,
          "autoplay": 1
        }
      ]
    },
    {
      "title": "irregular meter",  
      "tracks": [
        {
          "song": "future rainer pethe",
          "name": "piano",
          "notes": "This track demonstrates how Samplton can be used to create and perform an unusual 19/4 rhythm.",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/future-zac.mp3",
          "bpm": 180,
          "signature": 19,
          "bars": 2,
          "repeat": "",
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": "",
          "notesVisible": true,
          "autoplay": 1
        },
        {
          "song": "future rainer pethe",
          "name": "piano bass",
          "notes": "It shows that loops and musical structures are not limited to standard time signatures such as 4/4 — even complex",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/future-zac1.mp3",
          "bpm": 180,
          "signature": 19,
          "bars": 4,
          "repeat": "",
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": "",
          "notesVisible": true,
          "autoplay": 1
        },
        {
          "song": "future rainer pethe",
          "name": "theme",
          "notes": "unconventional rhythmic patterns can be built and played live.",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/future-Vyhr1.mp3",
          "bpm": 180,
          "signature": 19,
          "bars": 8,
          "repeat": "",
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": "",
          "notesVisible": true,
          "autoplay": 1
        },
        {
          "song": "future rainer pethe",
          "name": "part",
          "notes": "",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/future-Part.mp3",
          "bpm": 180,
          "signature": 19,
          "bars": 8,
          "repeat": "",
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": "",
          "notesVisible": true,
          "autoplay": 1
        },
        {
          "song": "future rainer pethe",
          "name": "theme",
          "notes": "",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/future-Vyhr2.mp3",
          "bpm": 180,
          "signature": 19,
          "bars": 6,
          "repeat": "",
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": "",
          "notesVisible": true,
          "autoplay": 1
        },
        {
          "song": "future rainer pethe",
          "name": "part",
          "notes": "",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/future-Part-pred-kon.mp3",
          "bpm": 180,
          "signature": 19,
          "bars": 4,
          "repeat": 2,
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": "",
          "notesVisible": true,
          "autoplay": 1
        },
        {
          "song": "future rainer pethe",
          "name": "fin",
          "notes": "",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/future-Part-Kon.mp3",
          "bpm": 180,
          "signature": 5,
          "bars": 56,
          "repeat": "",
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": "",
          "notesVisible": true,
          "autoplay": 1
        },
        {
          "song": "future rainer pethe",
          "name": "future by rainer pethe",
          "notes": "",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/future-Part-Kon1.mp3",
          "bpm": 180,
          "signature": 5,
          "bars": 8,
          "repeat": "",
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": "",
          "notesVisible": true,
          "autoplay": 1
        }
      ]
    },
    {
      "title": "drums",
      "tracks": [
        {
          "song": "drums",
          "name": "Bass Drum",
          "notes": "Set Quantize to NONE to disable looping. Each pad will play only once, allowing you to trigger samples freely like drums, without AUTO mode or automatic looping. Samplton is not primarily designed as a drum-pad application. Its main purpose is precise live playback and synchronization with other devices, as well as practicing and preparing your live performance.",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/08/Bass-Drum-1.wav",
          "bpm": "",
          "signature": "",
          "bars": "",
          "repeat": "",
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": "",
          "notesVisible": false
        },
        {
          "song": "drums",
          "name": "High Conga",
          "notes": "",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/08/High-Conga-1.wav",
          "bpm": "",
          "signature": "",
          "bars": "",
          "repeat": "",
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": ""
        },
        {
          "song": "drums",
          "name": "Claves",
          "notes": "",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/08/Claves.wav",
          "bpm": "",
          "signature": "",
          "bars": "",
          "repeat": "",
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": ""
        },
        {
          "song": "drums",
          "name": "Side Stick",
          "notes": "",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/08/Ensoniq-SQ-1-Side-Stick.wav",
          "bpm": "",
          "signature": "",
          "bars": "",
          "repeat": "",
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": ""
        }
      ]
    },{
      "tracks": [
       
        {
          "song": "čo s vami",
          "name": "sloha1",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/05/Slo1.mp3",
          "notes": "",
          "repeat": 1,
          "fadeintime": 0.1,
          "start_at": 0.02,
          "signature": 4,
          "fadein": "",
          "bars": 24,
          "bpm": 142
        },
        {
          "bars": 24,
          "notes": "",
          "bpm": 142,
          "start_at": 0.02,
          "fadein": "",
          "repeat": 1,
          "fadeintime": 0.1,
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/05/Slo2.mp3",
          "signature": 4,
          "song": "čo s vami",
          "name": "Sloha2"
        },
        {
          "bars": 24,
          "bpm": 142,
          "repeat": 1,
          "signature": 4,
          "fadein": "",
          "fadeintime": 0.1,
          "notes": "",
          "name": "Sloha3",
          "start_at": 0.02,
          "song": "čo s vami",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/05/Slo3.mp3"
        },
        {
          "bpm": 142,
          "fadein": "",
          "signature": 4,
          "name": "ref short",
          "fadeintime": 0.1,
          "song": "čo s vami",
          "notes": "",
          "bars": 32,
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/05/Ref-short.mp3",
          "start_at": 0.02,
          "repeat": 1
        },
        {
          "song": "čo s vami",
          "signature": 4,
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/05/Prech.mp3",
          "name": "prech",
          "start_at": 0.02,
          "repeat": 2,
          "fadein": "",
          "notes": "",
          "bars": 4,
          "fadeintime": 0.1,
          "bpm": 142
        },
        {
          "song": "čo s vami",
          "notes": "",
          "midCC": "",
          "repeat": "",
          "midiPC": "",
          "name": "sloha4",
          "fadein": "",
          "signature": "",
          "fadeintime": "",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/05/Slo3.mp3",
          "bpm": 142,
          "start_at": "",
          "bars": 24
        },
        {
          "name": "ref long",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/05/Ref-long.mp3",
          "start_at": "",
          "fadeintime": "",
          "fadein": "",
          "signature": "",
          "midCC": "",
          "notes": "",
          "bars": 56,
          "bpm": 142,
          "song": "čo s vami",
          "midiPC": "",
          "repeat": ""
        },
        {
          "signature": "",
          "bpm": 142,
          "repeat": 1,
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/05/Zac.mp3",
          "song": "čo s vami",
          "midiPC": "",
          "start_at": "",
          "bars": 4,
          "notes": "",
          "midCC": "",
          "fadein": "",
          "fadeintime": "",
          "name": "po ref"
        },
        {
          "fadein": "",
          "name": "ref bez",
          "notes": "",
          "midCC": "",
          "bars": 99,
          "signature": "",
          "song": "čo s vami",
          "start_at": "",
          "fadeintime": "",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/05/Ref-Bez.mp3",
          "midiPC": "",
          "bpm": 142,
          "repeat": ""
        },
        {
          "name": "dub",
          "midCC": "",
          "notes": "",
          "fadein": "",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/Co-s-vami-Dub.mp3",
          "bpm": 142,
          "bars": 8,
          "start_at": "",
          "fadeintime": "",
          "song": "čo s vami",
          "signature": "",
          "repeat": "",
          "midiPC": ""
        }
      ],
      "title": "čo s vami"
    },
    {
      "title": "o krajine",
      "tracks": [
        {
          "song": "o krajine",
          "name": "zac",
          "notes": "",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/Okrajinne-zac-155-24.mp3",
          "bpm": 155,
          "signature": "",
          "bars": 4,
          "repeat": 2,
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": ""
        },
       
        {
          "song": "o krajine",
          "name": "flute",
          "notes": "",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/Okrajinne-Flute-.mp3",
          "bpm": 155,
          "signature": "",
          "bars": 8,
          "repeat": "",
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": ""
        },
        {
          "song": "o krajine",
          "name": "prech",
          "notes": "",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/Okrajinne-zac-155-24.mp3",
          "bpm": 155,
          "signature": "",
          "bars": 2,
          "repeat": 1,
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": ""
        },
        {
          "song": "o krajine",
          "name": "flazo",
          "notes": "",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/Okrajinne-Flazo.mp3",
          "bpm": 155,
          "signature": "",
          "bars": 8,
          "repeat": "",
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": ""
        },
        {
          "song": "o krajine",
          "name": "flazo1",
          "notes": "",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/Okrajinne-Flazo1.mp3",
          "bpm": 155,
          "signature": "",
          "bars": 8,
          "repeat": 3,
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": ""
        },
        {
          "song": "o krajine",
          "name": "prech",
          "notes": "",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/Okrajinne-Prech.mp3",
          "bpm": 155,
          "signature": "",
          "bars": 4,
          "repeat": "",
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": ""
        },
        {
          "song": "o krajine",
          "name": "pokrac",
          "notes": "",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/Okrajinne-Pokrac.mp3",
          "bpm": 155,
          "signature": "",
          "bars": 8,
          "repeat": "",
          "start_at": "",
          "fadein": "on",
          "fadeintime": 0.1,
          "midiPC": "",
          "midCC": ""
        },
        {
          "song": "o krajine",
          "name": "syn",
          "notes": "",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/Okrajinne-Pokrac-syn.mp3",
          "bpm": 155,
          "signature": "",
          "bars": 40,
          "repeat": "",
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": ""
        },
        
        {
          "song": "o krajine",
          "name": "kon",
          "notes": "",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/Okrajinne-Koniec-.mp3",
          "bpm": 155,
          "signature": "",
          "bars": 8,
          "repeat": "",
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": ""
        },
        {
          "song": "o krajine",
          "name": "kon1",
          "notes": "",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/Okrajinne-Koniec1.mp3",
          "bpm": 155,
          "signature": "",
          "bars": 4,
          "repeat": "",
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": ""
        }
      ]
    },
    {
      "title": "zblískať",
      "tracks": [
        {
          "song": "zblískať",
          "name": "slak",
          "notes": "",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/Zbliskat-slak-zac.mp3",
          "bpm": 115,
          "signature": "",
          "bars": 4,
          "repeat": "",
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": ""
        },
        {
          "song": "zblískať",
          "name": "slak1",
          "notes": "",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/Zbliskat-slak-zac1.mp3",
          "bpm": 115,
          "signature": "",
          "bars": 12,
          "repeat": "",
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": ""
        },
        {
          "song": "zblískať",
          "name": "zac bass",
          "notes": "",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/Zbliskat-Zac-bass.mp3",
          "bpm": 115,
          "signature": "",
          "bars": 8,
          "repeat": "",
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": ""
        },
        {
          "song": "zblískať",
          "name": "bass 2",
          "notes": "",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/Zbliskat-Zac2-bass.mp3",
          "bpm": 115,
          "signature": "",
          "bars": 8,
          "repeat": "",
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": ""
        },
        {
          "song": "zblískať",
          "name": "vyhravka",
          "notes": "",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/Zbliskat-Zac-vyhravka.mp3",
          "bpm": 115,
          "signature": "",
          "bars": 8,
          "repeat": "",
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": ""
        },
        {
          "song": "zblískať",
          "name": "ref",
          "notes": "",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/Zbliskat-Ref.mp3",
          "bpm": 115,
          "signature": 2,
          "bars": 57,
          "repeat": "",
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": ""
        },
        {
          "song": "zblískať",
          "name": "clap",
          "notes": "",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/Zbliskat-Clap.mp3",
          "bpm": 115,
          "signature": 4,
          "bars": 4,
          "repeat": 2,
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": ""
        },
        {
          "song": "zblískať",
          "name": "bass",
          "notes": "",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/Zbliskat-Zac-bass.mp3",
          "bpm": 115,
          "signature": "",
          "bars": 4,
          "repeat": 2,
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": ""
        },
        {
          "song": "zblískať",
          "name": "bass1",
          "notes": "",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/Zbliskat-Zac2-bass.mp3",
          "bpm": 115,
          "signature": "",
          "bars": 8,
          "repeat": "",
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": ""
        },
        {
          "song": "zblískať",
          "name": "vyhravka",
          "notes": "",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/Zbliskat-Zac-vyhravka.mp3",
          "bpm": 115,
          "signature": "",
          "bars": 8,
          "repeat": "",
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": ""
        },
        {
          "song": "zblískať",
          "name": "ref cut",
          "notes": "",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/Zbliskat-Ref-cut.mp3",
          "bpm": 115,
          "signature": 2,
          "bars": 52,
          "repeat": "",
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": ""
        },
        {
          "song": "zblískať",
          "name": "ref",
          "notes": "",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/Zbliskat-Ref2.mp3",
          "bpm": 115,
          "signature": 2,
          "bars": 57,
          "repeat": "",
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": ""
        },
        {
          "song": "zblískať",
          "name": "zaver",
          "notes": "",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/Zbliskat-Kon-115-bpm.mp3",
          "bpm": 115,
          "signature": "",
          "bars": 4,
          "repeat": "",
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": ""
        },
        {
          "song": "zblískať",
          "name": "zaver",
          "notes": "",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/Zbliskat-Kon-115-bpm.mp3",
          "bpm": 115,
          "signature": "",
          "bars": 8,
          "repeat": "",
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": ""
        }
      ]
    },
    {
      "title": "like a blues",
      "tracks": [
        {
          "song": "like a blues",
          "name": "piano",
          "notes": "",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/Like-a-blues-klavir-110.mp3",
          "bpm": 110,
          "signature": 2,
          "bars": 58,
          "repeat": "",
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": ""
        },
        {
          "song": "like a blues",
          "name": "piano tema",
          "notes": "",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/Like-a-blues-Zac-58.mp3",
          "bpm": 110,
          "signature": 2,
          "bars": 58,
          "repeat": "",
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": ""
        },
        {
          "song": "like a blues",
          "name": "regge",
          "notes": "",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/Like-a-blues-Regge-60.mp3",
          "bpm": 110,
          "signature": 4,
          "bars": 30,
          "repeat": "",
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": ""
        },
        {
          "song": "like a blues",
          "name": "regge1",
          "notes": "",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/Like-a-blues-Regge2-38.mp3",
          "bpm": 110,
          "signature": 4,
          "bars": 19,
          "repeat": "",
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": ""
        },
        {
          "song": "like a blues",
          "name": "amb piano",
          "notes": "",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/Like-a-blues-Piano.mp3",
          "bpm": 110,
          "signature": 4,
          "bars": 2,
          "repeat": 3,
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": ""
        },
        {
          "song": "like a blues",
          "name": "amb piano 1",
          "notes": "",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/Like-a-blues-Piano1.mp3",
          "bpm": 110,
          "signature": 4,
          "bars": 2,
          "repeat": 2,
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": ""
        },
        {
          "song": "like a blues",
          "name": "amb piano 2",
          "notes": "",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/Like-a-blues-Piano3.mp3",
          "bpm": 110,
          "signature": 1,
          "bars": 18,
          "repeat": "",
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": ""
        },
        {
          "song": "like a blues",
          "name": "amb bass piano",
          "notes": "",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/Like-a-blues-Jazz-bass.mp3",
          "bpm": 110,
          "signature": 4,
          "bars": 8,
          "repeat": "",
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": ""
        },
        {
          "song": "like a blues",
          "name": "jazz",
          "notes": "",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/Like-a-blues-Jazz.mp3",
          "bpm": 110,
          "signature": 4,
          "bars": 18,
          "repeat": "",
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": ""
        },
        {
          "song": "like a blues",
          "name": "jazz1",
          "notes": "",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/Like-a-blues-Jazz1.mp3",
          "bpm": 110,
          "signature": 4,
          "bars": 20,
          "repeat": "",
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": ""
        },
        {
          "song": "like a blues",
          "name": "prechod",
          "notes": "",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/Like-a-blues-Jazz-po.mp3",
          "bpm": 110,
          "signature": 4,
          "bars": 4,
          "repeat": "",
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": ""
        }
      ]
    },
    {
      "title": "zapalka",
      "tracks": [
        {
          "song": "zapalka",
          "name": "ruch",
          "notes": "",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/Zapalka-ruch-200.mp3",
          "bpm": 200,
          "signature": 3,
          "bars": 8,
          "repeat": "",
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": ""
        },
        {
          "song": "zapalka",
          "name": "ruch bongo",
          "notes": "",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/Zapalka-ruch-Bong.mp3",
          "bpm": 200,
          "signature": 3,
          "bars": 8,
          "repeat": "",
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": ""
        },
        {
          "song": "zapalka",
          "name": "zac",
          "notes": "",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/Zapalka-Zac-kus.mp3",
          "bpm": 200,
          "signature": 3,
          "bars": 16,
          "repeat": "",
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": ""
        },
        {
          "song": "zapalka",
          "name": "sloha pol",
          "notes": "",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/Zapalka-sloha-pol.mp3",
          "bpm": 200,
          "signature": 3,
          "bars": 32,
          "repeat": "",
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": ""
        },
        {
          "song": "zapalka",
          "name": "sloha",
          "notes": "",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/Zapalka-sloha-Cela.mp3",
          "bpm": 200,
          "signature": 3,
          "bars": 84,
          "repeat": "",
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": ""
        },
        {
          "song": "zapalka",
          "name": "pokrac",
          "notes": "",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/Zapalka-pokrac.mp3",
          "bpm": 200,
          "signature": 3,
          "bars": 16,
          "repeat": "",
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": ""
        },
        {
          "song": "zapalka",
          "name": "bass",
          "notes": "",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/Zapalka-pokrac-bass.mp3",
          "bpm": 200,
          "signature": 3,
          "bars": 16,
          "repeat": "",
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": ""
        },
        {
          "song": "zapalka",
          "name": "bass1",
          "notes": "",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/Zapalka-pokrac-bass1.mp3",
          "bpm": 200,
          "signature": 3,
          "bars": 8,
          "repeat": "",
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": ""
        },
        {
          "song": "zapalka",
          "name": "bass prechod",
          "notes": "",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/Zapalka-pokrac-bass2.mp3",
          "bpm": 200,
          "signature": 3,
          "bars": 8,
          "repeat": "",
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": ""
        },
        {
          "song": "zapalka",
          "name": "tema",
          "notes": "",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/Zapalka-Koniec.mp3",
          "bpm": 200,
          "signature": 3,
          "bars": 24,
          "repeat": "",
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": ""
        },
        {
          "song": "zapalka",
          "name": "tema bez",
          "notes": "",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/Zapalka-Koniec1.mp3",
          "bpm": 200,
          "signature": 3,
          "bars": 32,
          "repeat": "",
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": ""
        },
        {
          "song": "zapalka",
          "name": "koniec",
          "notes": "",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/Zapalka-Koniec2.mp3",
          "bpm": 200,
          "signature": 3,
          "bars": 50,
          "repeat": "",
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": ""
        },
        {
          "song": "zapalka",
          "name": "sampel",
          "notes": "",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/Zapalka-Koniec-bez-1.mp3",
          "bpm": 200,
          "signature": 3,
          "bars": 48,
          "repeat": "",
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": ""
        }
      ]
    },
    {
      "title": "miesta v nas",
      "tracks": [
        {
          "song": "miesta v nas",
          "name": "zac ruch",
          "notes": "",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/Miesta-v-Nas-zac.mp3",
          "bpm": 110,
          "signature": "",
          "bars": 4,
          "repeat": "",
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": ""
        },
        {
          "song": "miesta v nas",
          "name": "sloha",
          "notes": "",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/Miesta-v-Nas-Sloha.mp3",
          "bpm": 110,
          "signature": "",
          "bars": 20,
          "repeat": "",
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": ""
        },
        {
          "song": "miesta v nas",
          "name": "flute",
          "notes": "",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/Miesta-v-Nas-Flute-110.mp3",
          "bpm": 110,
          "signature": "",
          "bars": 20,
          "repeat": "",
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": ""
        },
        {
          "song": "miesta v nas",
          "name": "sloha cut",
          "notes": "",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/Miesta-v-Nas-Sloha.mp3",
          "bpm": 110,
          "signature": "",
          "bars": 16,
          "repeat": "",
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": ""
        },
        {
          "song": "miesta v nas",
          "name": "zaver",
          "notes": "",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/Miesta-v-Nas-Zaver.mp3",
          "bpm": 110,
          "signature": "",
          "bars": 8,
          "repeat": "",
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": ""
        },
        {
          "song": "miesta v nas",
          "name": "prechod",
          "notes": "",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/Miesta-v-Nas-Pokrac-zac.mp3",
          "bpm": 110,
          "signature": "",
          "bars": 4,
          "repeat": "",
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": ""
        },
        {
          "song": "miesta v nas",
          "name": "flute",
          "notes": "",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/Miesta-v-Nas-Pokrac.mp3",
          "bpm": 110,
          "signature": "",
          "bars": 20,
          "repeat": 2,
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": ""
        },
        {
          "song": "miesta v nas",
          "name": "flute cut",
          "notes": "",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/Miesta-v-Nas-Pokrac.mp3",
          "bpm": 110,
          "signature": "",
          "bars": 16,
          "repeat": "",
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": ""
        },
        {
          "song": "miesta v nas",
          "name": "zaver",
          "notes": "",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/Miesta-v-Nas-Zaver.mp3",
          "bpm": 110,
          "signature": "",
          "bars": 8,
          "repeat": "",
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": ""
        },
        {
          "song": "miesta v nas",
          "name": "koniec",
          "notes": "",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/Miesta-v-Nas-Pokrac-zac.mp3",
          "bpm": 110,
          "signature": "",
          "bars": 4,
          "repeat": "",
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": ""
        }
      ]
    },
    {
      "title": "karma sala",
      "tracks": [
        {
          "song": "karma sala",
          "name": "zac bass 1",
          "notes": "",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/Karma-Sala-zac-210.mp3",
          "bpm": 210,
          "signature": 9,
          "bars": 2,
          "repeat": 2,
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": ""
        },
        {
          "song": "karma sala",
          "name": "zac bass 2",
          "notes": "",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/Karma-Sala-zac-bass.mp3",
          "bpm": 210,
          "signature": 9,
          "bars": 8,
          "repeat": "",
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": ""
        },
        {
          "song": "karma sala",
          "name": "sloha spev",
          "notes": "",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/Karma-Sala-Sloha.mp3",
          "bpm": 210,
          "signature": 9,
          "bars": 28,
          "repeat": "",
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": ""
        },
        {
          "song": "karma sala",
          "name": "refren",
          "notes": "",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/Karma-Sala-Ref.mp3",
          "bpm": 210,
          "signature": 9,
          "bars": 16,
          "repeat": "",
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": ""
        },
        {
          "song": "karma sala",
          "name": "po refren",
          "notes": "",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/Karma-Sala-Ref-po.mp3",
          "bpm": 210,
          "signature": 9,
          "bars": 8,
          "repeat": "",
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": ""
        },
        {
          "song": "karma sala",
          "name": "sloha 2",
          "notes": "",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/Karma-Sala-Sloha2.mp3",
          "bpm": 210,
          "signature": 9,
          "bars": 16,
          "repeat": "",
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": ""
        },
        {
          "song": "karma sala",
          "name": "ref koniec",
          "notes": "",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/Karma-Sala-Ref2.mp3",
          "bpm": 210,
          "signature": 9,
          "bars": 8,
          "repeat": 4,
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": ""
        },
        {
          "song": "karma sala",
          "name": "sampel",
          "notes": "",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/Karma-Sala-sampel-rec.mp3",
          "bpm": 210,
          "signature": 9,
          "bars": 4,
          "repeat": "",
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": ""
        },
        {
          "song": "karma sala",
          "name": "sampel",
          "notes": "",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/Karma-Sala-sampel-.mp3",
          "bpm": 210,
          "signature": 9,
          "bars": 4,
          "repeat": "",
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": ""
        }
      ]
    },
    {
      "title": "ohnostroj",
      "tracks": [
        {
          "song": "ohnostroj",
          "name": "zac",
          "notes": "",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/Ohnostroj-zac-85.mp3",
          "bpm": 85,
          "signature": "",
          "bars": 4,
          "repeat": "",
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": ""
        },
        {
          "song": "ohnostroj",
          "name": "kopak",
          "notes": "",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/Ohnostroj-zac-kop.mp3",
          "bpm": 85,
          "signature": "",
          "bars": 4,
          "repeat": "",
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": ""
        },
        {
          "song": "ohnostroj",
          "name": "truba",
          "notes": "",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/Ohnostroj-zac-Truba.mp3",
          "bpm": 85,
          "signature": "",
          "bars": 4,
          "repeat": 2,
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": ""
        },
        {
          "song": "ohnostroj",
          "name": "sloha zac",
          "notes": "",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/Ohnostroj-Sloha-zac.mp3",
          "bpm": 85,
          "signature": "",
          "bars": 8,
          "repeat": "",
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": ""
        },
        {
          "song": "ohnostroj",
          "name": "sloha",
          "notes": "",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/Ohnostroj-Sloha-Cela.mp3",
          "bpm": 85,
          "signature": "",
          "bars": 16,
          "repeat": "",
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": ""
        },
        {
          "song": "ohnostroj",
          "name": "ref a sloha 2",
          "notes": "",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/Ohnostroj-Sloha-Cela.mp3",
          "bpm": 85,
          "signature": "",
          "bars": 24,
          "repeat": "",
          "start_at": 45.22,
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": ""
        },
        {
          "song": "ohnostroj",
          "name": "ref a zaver",
          "notes": "",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/Ohnostroj-Sloha-Cela.mp3",
          "bpm": 85,
          "signature": "",
          "bars": 48,
          "repeat": "",
          "start_at": 113,
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": ""
        }
      ]
    },
    {
      "title": "azuro",
      "tracks": [
        {
          "song": "azuro",
          "name": "zac",
          "notes": "",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/Azuro-zac-100.mp3",
          "bpm": 100,
          "signature": "",
          "bars": 4,
          "repeat": "",
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": ""
        },
        {
          "song": "azuro",
          "name": "tema",
          "notes": "",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/Azuro-Tema.mp3",
          "bpm": 100,
          "signature": "",
          "bars": 36,
          "repeat": "",
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": ""
        },
        {
          "song": "azuro",
          "name": "spev",
          "notes": "",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/Azuro-Spev.mp3",
          "bpm": 100,
          "signature": "",
          "bars": 36,
          "repeat": "",
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": ""
        },
        {
          "song": "azuro",
          "name": "solo",
          "notes": "",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/Azuro-Solo.mp3",
          "bpm": 100,
          "signature": "",
          "bars": 36,
          "repeat": "",
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": ""
        }
      ]
    },
    {
      "title": "05ka",
      "tracks": [
        {
          "song": "05ka",
          "name": "piano",
          "notes": "",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/05Ka-zac-110.mp3",
          "bpm": 110,
          "signature": 5,
          "bars": 8,
          "repeat": "",
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": ""
        },
        {
          "song": "05ka",
          "name": "piano zac",
          "notes": "",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/05Ka-zac-1.mp3",
          "bpm": 110,
          "signature": 5,
          "bars": 8,
          "repeat": "",
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": ""
        },
        {
          "song": "05ka",
          "name": "fender",
          "notes": "",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/05Ka-zac-Tema.mp3",
          "bpm": 110,
          "signature": 5,
          "bars": 16,
          "repeat": "",
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": ""
        },
        {
          "song": "05ka",
          "name": "piano nic",
          "notes": "",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/05Ka-Tema1.mp3",
          "bpm": 110,
          "signature": 5,
          "bars": 8,
          "repeat": "",
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": ""
        },
        {
          "song": "05ka",
          "name": "bass zac",
          "notes": "",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/05Ka-Tema2.mp3",
          "bpm": 110,
          "signature": 5,
          "bars": 8,
          "repeat": "",
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": ""
        },
        {
          "song": "05ka",
          "name": "bass syn",
          "notes": "",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/05Ka-Tema3Syn.mp3",
          "bpm": 110,
          "signature": 5,
          "bars": 8,
          "repeat": "",
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": ""
        },
        {
          "song": "05ka",
          "name": "bass",
          "notes": "",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/05Ka-Tema4Bass.mp3",
          "bpm": 110,
          "signature": 5,
          "bars": 8,
          "repeat": "",
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": ""
        },
        {
          "song": "05ka",
          "name": "tema",
          "notes": "",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/05Ka-Tema5.mp3",
          "bpm": 110,
          "signature": 5,
          "bars": 8,
          "repeat": "",
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": ""
        },
        {
          "song": "05ka",
          "name": "zaver",
          "notes": "",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/05Ka-Tema5Prech.mp3",
          "bpm": 110,
          "signature": 5,
          "bars": 8,
          "repeat": "",
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": ""
        },
        {
          "song": "05ka",
          "name": "o nieco",
          "notes": "",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/05Ka-Tema6-Spev.mp3",
          "bpm": 110,
          "signature": 5,
          "bars": 8,
          "repeat": "",
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": ""
        },
        {
          "song": "05ka",
          "name": "obraz sa",
          "notes": "",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/05Ka-Tema6-Spev-pol.mp3",
          "bpm": 110,
          "signature": 5,
          "bars": 4,
          "repeat": "",
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": ""
        },
        {
          "song": "05ka",
          "name": "rychly beat",
          "notes": "",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/05Ka-Tema7.mp3",
          "bpm": 110,
          "signature": 5,
          "bars": 8,
          "repeat": "",
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": ""
        },
        {
          "song": "05ka",
          "name": "opustis plaz",
          "notes": "",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/05Ka-Tema8.mp3",
          "bpm": 110,
          "signature": 5,
          "bars": 8,
          "repeat": "",
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": ""
        },
        {
          "song": "05ka",
          "name": "prechod",
          "notes": "",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/05Ka-Tema9-Prech.mp3",
          "bpm": 110,
          "signature": 5,
          "bars": 2,
          "repeat": "",
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": ""
        },
        {
          "song": "05ka",
          "name": "part2",
          "notes": "",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/05Ka-Koniec.mp3",
          "bpm": 110,
          "signature": 5,
          "bars": 4,
          "repeat": "",
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": ""
        },
        {
          "song": "05ka",
          "name": "part3",
          "notes": "",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/05Ka-Koniec1.mp3",
          "bpm": 110,
          "signature": 5,
          "bars": 4,
          "repeat": 2,
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": ""
        },
        {
          "song": "05ka",
          "name": "part4",
          "notes": "",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/05Ka-Koniec2.mp3",
          "bpm": 110,
          "signature": 5,
          "bars": 4,
          "repeat": 2,
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": ""
        },
        {
          "song": "05ka",
          "name": "zaver",
          "notes": "",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/05Ka-Koniec3.mp3",
          "bpm": 110,
          "signature": 5,
          "bars": 4,
          "repeat": "",
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": ""
        },
        {
          "song": "05ka",
          "name": "zaver1",
          "notes": "",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/05Ka-Koniec4.mp3",
          "bpm": 110,
          "signature": 5,
          "bars": 4,
          "repeat": "",
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": ""
        },
        {
          "song": "05ka",
          "name": "zaver2",
          "notes": "",
          "mp3": "https://www.divartwp.sk/wp-content/uploads/2026/04/05Ka-Koniec5.mp3",
          "bpm": 110,
          "signature": 5,
          "bars": 4,
          "repeat": "",
          "start_at": "",
          "fadein": "",
          "fadeintime": "",
          "midiPC": "",
          "midCC": ""
        }
      ]
    }
  ]
}